import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../auth.service';
import { LocalStorageKeys } from '../../shared/models/local-storage.model';
import { TOTP_CODE_LENGTH } from '../../shared/components/otp-input/otp-input.component';
import { isChallengeExpired, twoFactorErrorMessage } from './two-factor-errors';

@Component({
  selector: 'app-two-factor-verify',
  templateUrl: './two-factor-verify.component.html'
})
export class TwoFactorVerifyComponent implements OnInit {
  code = '';
  loading = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    if (!localStorage.getItem(LocalStorageKeys.TwoFactorChallenge)) {
      this.router.navigate(['/login']);
    }
  }

  isComplete(code: string): boolean {
    return (code || '').length === TOTP_CODE_LENGTH;
  }

  verify(code: string) {
    if (this.loading || !this.isComplete(code)) { return; }
    this.loading = true;
    this.authService.verifyTwoFactor(code).subscribe(() => {
      this.loading = false;
      this.router.navigate(['/']);
    }, (error: HttpErrorResponse) => {
      this.loading = false;
      this.code = '';
      if (isChallengeExpired(error)) {
        this.authService.abandonTwoFactorChallenge('Sesja logowania wygasła. Zaloguj się ponownie.');
        return;
      }
      this.toastr.error(twoFactorErrorMessage(error, 'Nieprawidłowy kod uwierzytelniający'));
    });
  }
}
